export default "__VITE_ASSET__DggmveDb__"